import { httpConstants } from "../constants";
import { httpService } from "../utility/httpService";

export default {
  deletereportedUsers,
  getreportedUsersList,
  blockUser,
  unblockUser,
  getblockUsersList,
  deleteblockedUsers,
  blockContent,
};

function getHeaders(){
  return {
      'Content-Type': httpConstants.CONTENT_TYPE.APPLICATION_JSON,
      'x-api-key': process.env.REACT_APP_API_KEY
  }
}


async function getreportedUsersList(data) {
  let url =
    process.env.REACT_APP_CONTENT_SERVICE_URL +
    httpConstants.API_END_POINT.REPORTED_CONTENTS +
    "?skip=" + Math.ceil(data.pageNum) + "&limit=" + data.perpage + "&sort=" + data.sorted;
  return httpService(
    httpConstants.METHOD_TYPE.GET,
    getHeaders(),
    {},
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject();
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}

async function deletereportedUsers(requestData) {
  let url =
    process.env.REACT_APP_CONTENT_SERVICE_URL +
    httpConstants.API_END_POINT.DELETE_REPORT;
  return httpService(
    httpConstants.METHOD_TYPE.PUT,
    getHeaders(),
    requestData,
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject();
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}

async function blockUser(requestdata) {
  let url =
    process.env.REACT_APP_CONTENT_SERVICE_URL +
    httpConstants.API_END_POINT.BLOCK_USERS;

  return httpService(
    httpConstants.METHOD_TYPE.POST,
    getHeaders(),
    requestdata,
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject();
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}

async function unblockUser(requestdata) {
  let url =
    process.env.REACT_APP_CONTENT_SERVICE_URL +
    httpConstants.API_END_POINT.UNBLOCK_USERS;

  return httpService(
    httpConstants.METHOD_TYPE.POST,
    getHeaders(),
    requestdata,
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject();
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}

async function getblockUsersList(data) {
  let url =
    process.env.REACT_APP_CONTENT_SERVICE_URL +
    httpConstants.API_END_POINT.BLOCKED_USERS +
    "?skip=" + Math.ceil(data.pageNum) + "&limit=" + data.perpage + "&sort=" + data.sorted;
  return httpService(
    httpConstants.METHOD_TYPE.GET,
    getHeaders(),
    {},
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject();
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}

async function deleteblockedUsers(requestData) {
  let url =
    process.env.REACT_APP_CONTENT_SERVICE_URL +
    httpConstants.API_END_POINT.DELETE_ENTRY;
  return httpService(
    httpConstants.METHOD_TYPE.POST,
    getHeaders(),
    requestData,
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject();
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}
async function blockContent(requestData) {
  let url =
    process.env.REACT_APP_CONTENT_SERVICE_URL +
    httpConstants.API_END_POINT.BLOCK_CONTENT;
  return httpService(
    httpConstants.METHOD_TYPE.POST,
    getHeaders(),
    requestData,
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject();
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}